var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHyperlink = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#0061FE",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  clipPath: "url(#clip0_1797_38635)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.47 18.105-4.227 4.227a3.987 3.987 0 0 1-5.637 0l-.94-.94a3.985 3.985 0 0 1 0-5.634L7.774 9.65a3.987 3.987 0 0 1 5.637 0l.939.94"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.531 5.893 4.227-4.226a3.986 3.986 0 0 1 5.637 0l.94.938a3.985 3.985 0 0 1 0 5.635l-6.107 6.107a3.985 3.985 0 0 1-5.637 0l-.939-.94"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1797_38635"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export { SvgIconHyperlink as ReactComponent };